import React, { Component } from 'react';

import styles from './FileUpload.css';

export default class FileUpload extends Component {
  render() {
    const { image, multiple, deleteLabel, deleteAction, uploadAction, id } = this.props;

    let images = null;

    if (!multiple && image) {
      images = (
        <div className={styles.image}>
          <img src={image} />
          <span onClick={() => deleteAction(image)}>{deleteLabel}</span>
        </div>
      );
    }

    if (multiple && image) {
      images = image.map(item => (
        <div className={styles.image}>
          <img src={item} />
          <span onClick={() => deleteAction(item)}>{deleteLabel}</span>
        </div>
      ))
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.imagesWrapper}>{images}</div>
        {
          (!image || multiple) &&
          <input id={id} type="file" onChange={uploadAction} multiple={multiple} />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js